module.exports = __webpack_public_path__ + "static/img/qualifications_row_13.b0674b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_company/qualifications/qualifications_row_13.png
// module id = 9UrI
// module chunks = 1